import { http } from "@/lib/http";

import type { OperationStatus } from "./types";

/** A database's progress as an operation: Active is done, Error has failed
 *  (with the reason the backend puts in product words), anything else runs. */
export async function getDatabaseProgress(instanceId: string): Promise<OperationStatus> {
  const { data } = await http.get<{
    id: string;
    status: string | null;
    fault: { message: string } | null;
  }>(`/database/instances/${encodeURIComponent(instanceId)}`);
  const status = (data.status ?? "").toUpperCase();
  if (status === "ACTIVE" || status === "HEALTHY") {
    return { workflow_id: instanceId, status: "completed", result_id: data.id };
  }
  if (status === "ERROR" || status === "FAILED") {
    return {
      workflow_id: instanceId,
      status: "failed",
      result_id: data.id,
      error: data.fault?.message ?? "The database could not be created.",
    };
  }
  return { workflow_id: instanceId, status: "running" };
}

/** Poll the live status of an async operation by its Temporal workflow id. */
export async function getOperation(workflowId: string): Promise<OperationStatus> {
  const { data } = await http.get<OperationStatus>(
    `/operations/${encodeURIComponent(workflowId)}`,
  );
  return data;
}
